import {debug, error} from 'core/log';
import {onDocumentReady} from '@exadel/esl/modules/esl-utils/dom/ready';

if (!window['~hpe~']) {
  Object.defineProperty(window, '~hpe~', {value: {coreReady: false}});
  Object.defineProperty(window['~hpe~'], '$coreReady', {
    value: new Promise(function (resolve) {
      window.addEventListener('hpe:core:ready', resolve.bind(this, window['~hpe~']));
    })
  });
  error('System: Page corrupted. T-p scripts can be unaware of core state. Core ns reinitialized.');
}

export const ns = window['~hpe~'];

ns._compilers = ns._compilers || {};

export const requireModule = (alias, es6 = true) => {
  // eslint-disable-next-line
  if (!(alias in __webpack_modules__)) return null;
  // eslint-disable-next-line
  let module = __webpack_require__(alias);
  if (es6 && module && module.__esModule && module.default) {
    module = module.default;
  }
  return module || null;
};
ns.requireModule = requireModule;

function compile($context, name) {
  const compiler = ns._compilers[name];
  if (typeof compiler === 'function') {
    compiler($context);
  } else {
    error(`Compiler ${name} not found`);
  }
}
export function $compile($context, name) {
  if (typeof name === 'string') {
    compile($context, name);
  } else if (Array.isArray(name)) {
    name.forEach((cname) => compile($context, cname));
  } else {
    Object.keys(ns._compilers).forEach((cname) => compile($context, cname));
  }
}
export function createCompiler(name, initFn) {
  if (ns._compilers[name]) {
    throw new Error(`Compiler ${name} already in use`);
  }
  function compiler(context) {
    debug(`System: Executing compiler "${name}" ...`);
    context = jQuery(context);
    const $conditional = (selector) => context.is(selector) ? context : context.find(selector);
    initFn.call(this, $conditional);
  }
  compiler.alias = name;
  return (ns._compilers[name] = compiler);
}
ns.$compile = $compile;

export const onDOMReady = onDocumentReady;
ns.onDOMReady = onDOMReady;

// Set ready state marker
setTimeout(() => onDocumentReady(() => {
  ns.coreReady = true;
  document.body.setAttribute('core-ready', '');
  window.dispatchEvent(new CustomEvent('hpe:core:ready', {detail: ns}));
  debug('System: Core Ready state triggered.');
}), 10);

export default ns;
